import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import DirectorySearch from './search';
import DirectoryList from './directoryList';
import useDirectorySearch from './useDirectorySearch';
import * as styles from './styles';

function Directory({ onSync, onShare }) {
    const {
        industries,
        activeIndustries,
        searchInputValue,
        whatshotEnabled,
        directoryPublishers,
        filteredDirectoryPublishers,
        onSearchText,
        onToggleWhatshot,
        onToggleIndustry,
        onClearIndustries,
    } = useDirectorySearch();

    function renderSectionHeader() {
        return (
            <Box sx={styles.sectionHeader}>
                <Typography sx={styles.eyebrow}>Directory</Typography>
                <Typography variant="h2" sx={styles.title}>
                    Every publisher on{' '}
                    <Box component="span" sx={styles.gradientEcal}>ECAL</Box>
                </Typography>
                <Typography sx={styles.subtitle}>
                    Search the full directory. Multi-select categories to broaden your results.
                </Typography>
            </Box>
        );
    }

    return (
        <Box component="section" sx={styles.section}>
            <Container maxWidth="xl">
                {renderSectionHeader()}

                <DirectorySearch
                    industries={industries}
                    activeIndustries={activeIndustries}
                    searchText={searchInputValue}
                    whatshotEnabled={whatshotEnabled}
                    totalCount={directoryPublishers.length}
                    filteredCount={filteredDirectoryPublishers.length}
                    onSearchText={onSearchText}
                    onToggleWhatshot={onToggleWhatshot}
                    onToggleIndustry={onToggleIndustry}
                    onClearIndustries={onClearIndustries}
                />

                <DirectoryList
                    publishers={filteredDirectoryPublishers}
                    onSync={onSync}
                    onShare={onShare}
                />
            </Container>
        </Box>
    );
}

export default Directory;
